import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[tbOnlyNumber]',
})
export class TbOnlyNumberDirective {

  constructor(private elementRef: ElementRef,
              private injector: Injector) {
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this.elementRef.nativeElement.value;
    this.elementRef.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if (initalValue !== this.elementRef.nativeElement.value) {
      event.stopPropagation();
      const ngControl = this.injector.get<NgControl>(NgControl, null);
      if (ngControl && ngControl.control) {
        ngControl.control.setValue(this.elementRef.nativeElement.value);
      }
    }
  }
}
